import { render, staticRenderFns } from "./IconCircle.vue?vue&type=template&id=30990e71&scoped=true&"
import script from "./IconCircle.vue?vue&type=script&lang=js&"
export * from "./IconCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30990e71",
  null
  
)

export default component.exports